import { Component } from '@angular/core';
import {
  BackendDataSourceService,
  DataSource,
  GenericParamsComponent,
  ItemView,
  ItemViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { first, Observable, tap } from 'rxjs';

import { NestedViewStrategy } from '@app/shared';
import { InMemoryDataSourceService } from './services/in-memory-data-source.service';

@Component({
  selector: 'app-editable-itemlist',
  templateUrl: './editableitemlist.component.html',
  providers: [
    {
      provide: BackendDataSourceService,
      useClass: InMemoryDataSourceService
    },
    {
      provide: DataSource,
      useExisting: BackendDataSourceService
    }
  ]
})
export class EditableItemListComponent extends GenericParamsComponent {
  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object = {};
  currentViewStateFilter: object = {};
  showTableInOverlay: false;

  parentItem$: Observable<any>;

  constructor(protected itemViewProvider: ItemViewProviderDirective<ItemView>) {
    super();
    this.parentItem$ = this.itemViewProvider.item$;
  }

  protected doChangedOutputParam() {
    // throw new Error('Method not implemented.');
  }
  protected doChangedInputParam() {
    // naziv view-a odgovara nazivu atributa
    this.currentViewName = NestedViewStrategy.viewNameFromParentAttr(
      this.inputParam.attributeMetadata
    );
    this.itemViewProvider.item$
      .pipe(
        tap((item: any) => {
          this.currentViewState = NestedViewStrategy.viewStateFromParentItem(
            this.inputParam.attributeMetadata,
            item
          );
        }),
        first()
      )
      .subscribe();
    this.showTableInOverlay = this.inputParam.showInOverlay || false;
  }

  doDynamicInit() {
    // nothing to be done
  }
}
